import { render, staticRenderFns } from "./profile-client.vue?vue&type=template&id=38ca6a31&scoped=true"
import script from "./profile-client.vue?vue&type=script&lang=js"
export * from "./profile-client.vue?vue&type=script&lang=js"
import style0 from "./profile-client.vue?vue&type=style&index=0&id=38ca6a31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca6a31",
  null
  
)

export default component.exports